import { ViewportRuler } from '@angular/cdk/scrolling';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Customer } from '@app/models/customers/Customer';
import { FerienHauserHometogo } from '@app/models/ferienhauser/Ferienhauser';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { EncryptionService } from '@app/services/encyption.service';
import { FavoritesService } from '@app/services/favorites.service';
import { FerienFiltersService } from '@app/services/ferienhauser/ferieneFilters.service';
import { FerienHauserService } from '@app/services/ferienhauser/ferienHauser.service';
import { OfferpackService } from '@app/services/offerpack.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TvangebotimagevideoComponent } from '../modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Partner } from '@app/models/partner/IPartner';

interface Offer {
    mitprc: string;
    buchbarok: boolean;
    favoritePayementType: string;
    zahlungsarten: string[];
    storno: {
        agb_url: string;
        agb_name: string;
    };
}
@Component({
    selector: 'clever-ferienhauseroffer',
    templateUrl: './ferienhauseroffer.component.html',
    styleUrls: ['./ferienhauseroffer.component.scss'],
    standalone: false
})
export class FerienhauserofferComponent implements OnInit, OnDestroy {
    protected readonly _destroy = new Subject<void>();
    @ViewChild('trigger') trigger: ElementRef;
    @ViewChild('triggerZeit') triggerZeit: ElementRef;
    @ViewChild('triggerKind') triggerKind: ElementRef;
    tmp_real: FerienFIlters;
    images: any[];
    offer: Offer = {} as Offer;

    loadingcheck: boolean = true;
    startDate: boolean = false;
    endDate: boolean = false;
    isOpenZeit: boolean = false;

    ferienHauser: FerienHauserHometogo;
    vals = [];
    valsKind = [];
    isBrowser: boolean = false;
    isFilterchanged: boolean = false;
    loading: boolean = false;
    buchbarok: boolean = false;
    impLoading: boolean = false;

    rating: string[] = [];

    prcs: any;
    desktopTemplate: string = 'xl';
    inFavorites: boolean;
    shareLink: string = '';
    currentCustomer: Customer;
    partner: Partner;

    ages: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    constructor(
        protected ferienFiltersService: FerienFiltersService,
        protected ferienService: FerienHauserService,
        protected encservice: EncryptionService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected favoritesService: FavoritesService,
        protected guardService: AuthGuardService,
        protected mediaObserver: BreakpointObserver,
        protected viewportRuler: ViewportRuler,
        protected changeDetectorRef: ChangeDetectorRef,
        protected titleService: Title,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected metaService: Meta,
        protected offerpackServie: OfferpackService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            const cleverstyle = document.getElementById('clever-custom-content-style');
            if (cleverstyle) {
                cleverstyle.innerText = '';
            }

            const cleverscript = document.getElementById('clever-custom-content-script');
            if (cleverscript) {
                cleverscript.innerHTML = '';
            }
            this.initMedia();
            this.initPartner();
        }

        this.setNoIndex();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this._destroy)
        ).subscribe((obj) => {
            if (obj?.partnerid?.length > 0) {
                this.partner = obj;
                this.initAuth();
                this.initFilters();
            }
        });
    }

    setNoIndex(): void {
        this.metaService.updateTag({ name: 'robots', content: 'noindex' });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.changeDetectorRef.detectChanges();
    }

    async initAuth() {
        this.authService.auth$.pipe(
            takeUntil(this._destroy)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
            this.changeDetectorRef.detectChanges();
        });
    }

    initFilters() {
        this.ferienFiltersService.getfilters$.pipe(
            takeUntil(this._destroy)
        ).subscribe(params => {
            if (params) {
                this.tmp_real = JSON.parse(JSON.stringify(params));
                this.getFerienHauser();
            }
        });
    }

    async setTitle(title) {
        this.titleService.setTitle(title);
    }

    ngOnDestroy(): void {
        this._destroy.next();
        this._destroy.complete();
    }

    async getFerienHauser() {
        this.loading = true;
        // console.log(this.tmp_real)
        this.ferienService.request({
            apikey: this.partner?.hometogo?.apikey,
            origin: this.partner?.hometogo?.origin,
            id: this.tmp_real.obj_id,
            arrival: this.tmp_real.start,
            duration: Number(this.tmp_real.dauer),
            adults: this.tmp_real.adults,
            children: this.tmp_real.children,
            childrenAges: this.tmp_real.childrenAges,
        }, 'getObj').pipe(
            takeUntil(this._destroy)
        ).subscribe(val => {
            // console.log(val);
            this.loading = false;
            this.isFilterchanged = false;
            if (val) {
                this.ferienHauser = val;
                this.setTitle(this.ferienHauser?.originalTitle?.length > 0 ? this.ferienHauser?.originalTitle : this.ferienHauser?.title);
                this.buchbarok = true;
            } else {
                this.buchbarok = false;
            }
            this.getimages();
            this.initRating();
        });
    }

    async getimages() {
        if (this.ferienHauser?.images?.length > 0) {
            this.images = [];
            for (let i = 0; i < this.ferienHauser.images.length; i++) {
                this.images.push(this.ferienHauser.images[i].large);
            }
        }
        this.changeDetectorRef.detectChanges();
    }

    async gotoBooking() {
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = this.ferienHauser?.link;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    async initRating() {
        this.rating = [];
        this.changeDetectorRef.detectChanges();
        const catg = Number(String(this.ferienHauser?.rating?.stars).replace(/,/g, '.').replace(/\+/g, ''));
        for (let i = 0; i < Math.floor(catg); i++) {
            this.rating.push('100%');
        }
        if (catg > Math.floor(catg)) {
            this.rating.push(((catg - Math.floor(catg)) * 100).toFixed(0) + '%');
        }
        for (let i = 0; i < 5 - Math.ceil(catg); i++) {
            this.rating.push('0%');
        }
        this.changeDetectorRef.detectChanges();
    }

    async changeurl() {
        const navigationExtras: NavigationExtras = {
            queryParams: { params: this.encservice.encrypt(this.tmp_real) }
        };
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['ferienhause'], navigationExtras)
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    createLink(): void {
        if (this.tmp_real) {
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(this.tmp_real) }
            };
            const url = this.router.serializeUrl(
                this.router.createUrlTree(['ferienhauser-offer'], navigationExtras)
            );
            this.shareLink = url.toString();
        } else {
            console.log('- error with filters -');
        }
    }

    async addRemoveToFromFavorite(ev) {
        ev.stopPropagation()
        if (this.inFavorites) {
            this.favoritesService.removeFerienhauser(this.ferienHauser?.id);
            this.inFavorites = false;
        } else {
            this.favoritesService.addFerienhauser({
                ferienHauser: this.ferienHauser,
                params: this.tmp_real
            });
            this.inFavorites = true;
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: null,
                images: this.images,
                videos: [],
                current: ev,
                to800: false,
                desktopTemplate: this.desktopTemplate
            }
        }
        const scrollHeight = window.scrollY;
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this._destroy)
        ).subscribe(() => {
            document.body.style.overflow = '';
            window.scrollTo(0, scrollHeight);
        });
    }

    async addToOfferpack() {
        this.impLoading = true;
        this.changeDetectorRef.detectChanges();
        const exp = {
            id: this.tmp_real.obj_id,
            arrival: this.tmp_real.start,
            duration: Number(this.tmp_real.dauer),
            adults: this.tmp_real.adults,
            children: this.tmp_real.children,
            childrenAges: this.tmp_real.childrenAges,
            username: this.currentCustomer.email
        };
        this.ferienService.request({
            offer: exp,
            partnerid: this.partner.partnerid
        }, 'insertobj').pipe(
            takeUntil(this._destroy)
        ).subscribe(objs => {
            if (objs?.id?.length > 0) {
                this.offerpackServie.addOffer({ offerid: objs.id, type: 'hometogo' });
            }
            this.impLoading = false;
            this.changeDetectorRef.detectChanges();
        });
    }

    async addAdult() {
        if ((this.ferienFiltersService.adults + this.ferienFiltersService.children) < this.ferienHauser.guests) {
            this.isFilterchanged = true;
            this.ferienFiltersService.adults++;
            this.ferienFiltersService.reisendeResult(false);
        }
    }

    async removeAdult() {
        if (this.ferienFiltersService.adults > 1) {
            this.isFilterchanged = true;
            this.ferienFiltersService.adults--;
            this.ferienFiltersService.reisendeResult(false);
        }
    }

    async addChildren() {
        if ((this.ferienFiltersService.adults + this.ferienFiltersService.children) < this.ferienHauser.guests) {
            this.isFilterchanged = true;
            this.ferienFiltersService.children++;
            this.ferienFiltersService.childrenAges.push(-1);
            this.ferienFiltersService.reisendeResult(false);
        }
    }

    async removeChildren() {
        if (this.ferienFiltersService.children > 0) {
            this.isFilterchanged = true;
            this.ferienFiltersService.children--;
            this.ferienFiltersService.childrenAges.pop();
            this.ferienFiltersService.reisendeResult(false);
        }
    }

    async changeAge() {
        this.ferienFiltersService.reisendeResult(false);
    }

    async changeDate(ev) {
        if (ev.end?.length > 0) {
            this.isOpenZeit = false;
            this.ferienFiltersService.reisezeitraumResult({ start: ev.start, end: ev.end }, true);
            this.ferienFiltersService.changeUrl();
        }
    }

    toggleDropdownZeit(ev) {
        ev && ev.srcEvent?.stopPropagation();
        this.isOpenZeit = false;
    }

    toggleTrigerZeit() {
        this.isOpenZeit = true;
    }

    async checkPreise() {
        this.getFerienHauser();
    }

}
